import {
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'semd-modal',
    templateUrl: './semd-modal.component.html',
    styleUrls: ['./semd-modal.component.scss'],
})
export class SemdModalComponent {
    @Input() data: Array<string> | null = null;
    constructor(public activeModal: NgbActiveModal) {}
    closeApp(event: MouseEvent) {
        event.stopPropagation();
        this.activeModal.close();
    }
}
